<template>
  <div class="vue-wrapper-sidebar">
    <div class="modal-window-header">
      <div class="modal-window-heading">
        <h3>Objekthistorikk</h3>
      </div>
      <a href="javascript:;" @click="closeSidebar()" class="modal-window-close-button modal-window-sidebar-close-button"><span>Lukk</span> <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-close"></use></svg></a>
    </div>

    <overlay-scrollbars v-if="!loading && items.length > 0" :options="{ className: 'modal-window-body gray os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
      <table class="small clickable" v-if="!loading && items.length > 0">
        <tr v-for="item in filteredItems" v-bind:key="item.Brukerloggid">
          <td>
            <a href="javascript:;" class="data-modal" @click="openHistoryModal(item)">
              <span class="avatar name right" :class="strToAvatarClass(item.bruker.initials)" v-if="item.bruker">
                {{item.bruker.initials}}
                <span class="name">{{item.bruker.full_name}}</span>
              </span>
              <span class="avatar name right" :class="strToAvatarClass('-')" v-else>
                -
                <span class="name">Ikke tilgjengelig</span>
              </span>

              <span class="title-container" v-if="item.Tabell === 'Objekt'">
                <span class="title" v-if="item.Endring === 'ukInsert'">Objekt opprettet</span>
                <span class="title" v-if="item.Endring === 'ukModify'">Objekt endret</span>
                <span class="title" v-if="item.Endring === 'ukDelete'">Objekt slettet</span>
                <span class="timestamp">{{item.Dato | avantidate}}</span>
              </span>
              <span class="title-container" v-else-if="item.Tabell === 'objektOppgaveEmail'">
                <span class="title">Usolgt objekt, e-post sendt til selger</span>
                <span class="timestamp">{{item.Dato | avantidate}}</span>
              </span>
              <span class="title-container" v-if="item.Tabell === 'BesiktPDF'">
                <span class="title" v-if="getBesiktEmail(item)">Besiktigelsesrapport sendt til {{getBesiktEmail(item)}}</span>
                <span class="title" v-else>Besiktigelsesrapport sendt</span>
                <span class="timestamp">{{item.Dato | avantidate}}</span>
              </span>
            </a>
          </td>
        </tr>
        <tr>
          <td style="text-align: center" colspan="2" v-if="!everythingLoaded && pageCount > 1">
            <div style="margin-top: 10px">
              <button href="javascript:;" @click="loadMore()" class="button secondary action glyph" v-if="!loading && !updating">
                <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-add"></use></svg>
                <span>Last fler</span>
              </button>
              <button href="javascript:;" class="button secondary action glyph loading" v-else>
                <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-add"></use></svg>
                <span>Laster fler <span class="loader-spinner"></span></span>
              </button>
            </div>
          </td>
          <td style="text-align: center" colspan="2" v-if="everythingLoaded || pageCount <= 1">
            <div style="margin-top: 10px">
              Alt har blitt lastet inn
            </div>
          </td>
        </tr>
      </table>

      <div class="expandable-search" :class="{'active': searchBoxActive, 'search-active': search != ''}" v-if="!loading && items.length > 0">
        <div class="input-container search no-margin comment">
          <input  class="rounded" type="text" placeholder="Søk i historikk…" v-model="search" v-on:keydown="onSearchInput" v-on:blur="toggleSearchbox(false)" v-on:focus="toggleSearchbox(true)">
          <button class="glyph-button" type="submit">Søk <svg width="14px" height="14px" viewBox="0 0 14 14"><use xlink:href="/static/sprites.svg#glyph-input-search"></use></svg></button>
          <a href="javascript:;" @click="clearSearch()" class="cancel-search"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-close"></use></svg></a>
        </div>
      </div>
    </overlay-scrollbars>

    <div class="modal-window-body gray" v-else>
      <TheLoader :active="loading"/>
      <TheEmptyList v-if="!loading && items.length < 1" :title="'Ingen historikk'" :message="''" :large="false" :icon="'button-glyph-history'"/>
    </div>
    <div class="sidebar-overlay" @click="closeSidebar()"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import bus from '@/plugins/event-bus'

export default {
  name: 'KundeKontraktObjektSidebarHistorikk',
  props: {
    kunde: {
      type: Object,
      required: true
    },
    kontrakt: {
      type: Object,
      required: true
    },
    objekt: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      currentPage: 1, // Just for the pagination component
      search: '',
      searchBoxActive: false,
      skipLogKeys: [
        'kundeadresse',
        'Sist_endret_av',
        'Sist_endret_tid',
        'Hbversion'
      ]
    }
  },
  created: function () {
    // Not in use, as we removed paging
    this.currentPage = this.queryParams.page || 1

    // Debounced input
    this.onSearchInput = this._.debounce(this.onSearchInput, 500)
  },
  computed: {
    ...mapGetters('objekthistory', [
      'items',
      'pageCount',
      'totalCount',
      'everythingLoaded',
      'queryParams',
      'loading',
      'updating'
    ]),
    filteredItems: function () {
      if (!this.search) {
        return this.items
      }

      return this.items.filter((i) => {
        return this._.includes(this._.toLower(i.Logg), this.search)
      })
    }
  },
  methods: {
    getBesiktEmail: function (item) {
      if (item.Tabell === 'BesiktPDF') {
        const data = item.Logg ? JSON.parse(item.Logg) : null

        if (data && data.Data && data.Data.Email) {
          return data.Data.Email
        }
      }

      return null
    },
    openHistoryModal: function (item) {
      if (item.Tabell === 'BesiktPDF') {
        this.openModal(
          'history-item-besikt-pdf-modal',
          {
            objekt: this.objekt,
            item: item,
            internalWindow: true
          },
          'split'
        )
      } else {
        this.openModal(
          'history-item-modal',
          {
            item: item
          }
        )
      }
    },
    clearSearch: function () {
      this.search = ''
      this.toggleSearchbox(false)
    },
    toggleSearchbox: function (mode) {
      if (mode === false) {
        this.searchBoxActive = this.search !== ''
      } else {
        this.searchBoxActive = true
      }
    },
    onSearchInput: function (e) {
      // In it's own method, so we can have debounce
      this.search = this._.toLower(e.target.value.trim())
    },
    loadMore: function () {
      let page = this.currentPage + 1

      if (page > this.pageCount) {
        return
      }

      // Make query to load more...
      let copiedParams = this._.clone(this.queryParams)
      this.currentPage = page
      copiedParams.page = this.currentPage

      this.$store.dispatch('objekthistory/reload', {
        Kundenr: this.kunde.Kundenr,
        Kontraktnr: this.kontrakt.Kontraktnr,
        Objektid: this.objekt.Objektid,
        queryParams: copiedParams
      }).then((response) => {
      })
    },
    changePage: function (page) {
      // Update a copy of the query params, to send to our store
      let copiedParams = this._.clone(this.queryParams)
      this.currentPage = page
      copiedParams.pdataage = this.currentPage

      this.$store.dispatch('objekthistory/reload', {
        Kundenr: this.kunde.Kundenr,
        Kontraktnr: this.kontrakt.Kontraktnr,
        Objektid: this.objekt.Objektid,
        queryParams: copiedParams
      })
    },
    closeSidebar: function () {
      bus.$emit('close-objekt-sidebar')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/KundeKontraktObjektSidebarHistorikk.vue